import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import AsyncSelect from 'react-select/lib/Async';

require('react-datetime/css/react-datetime.css');

class ClientForm extends React.Component {
  renderClientSelect = ({ meta: { touched, error, warning }, label, input }) => (
    <span className={`${error ? 'has-error' : ''}`}>
      <AsyncSelect
        // value={input.value}
        cacheOptions
        defaultOptions
        loadOptions={this.props.searchClients}
        getOptionValue={option => option}
        getOptionLabel={option => `${option.name}`}
        placeholder="Client Name…"
        styles={{
          control: styles => ({
            ...styles,
            borderColor: '#cccccc',
            minHeight: 32,
            WebkitTextFillColor: '#108ee9',
          }),
          dropdownIndicator: styles => ({
            ...styles,
            padding: 2,
          }),
          menu: styles => ({
            ...styles,
            zIndex: 99999,
            color: '#108ee9',
          }),
        }}
        menuPlacement="top"
        onChange={this.onClientChange}
      />
      {touched &&
        ((error && <small className="help-block">{error}</small>) ||
          (warning && <small className="help-block">{warning}</small>))}
    </span>
  );

  onClientChange = val => {
    this.props.change('client', val);
  };

  renderToggler = props => (
    <label className="checkbox-inline">
      <input type="checkbox" {...props.input} /> {props.label}
    </label>
  );
  render() {
    const { handleSubmit, pristine, submitting } = this.props;
    return (
      <div
      className="form-group well"
      onSubmit={handleSubmit}
      style={{ marginBottom: 20 }}
    >
        <div className="col-md-6">
          <Field
            className="form-control"
            name="client"
            component={this.renderClientSelect}
            type="text"
            label="Client"
          />
        </div>
        <div className="col-md-2">
          <Field
            className="form-control"
            name="isDefault"
            component={this.renderToggler}
            type="checkbox"
            label="Default"
          />
        </div>
        <div className="col-md-2">
          <Field
            className="form-control"
            name="isAnchorTenant"
            component={this.renderToggler}
            type="checkbox"
            label="Anchor"
          />
        </div>
        <div className="col-md-2">
          <button
            type="submit"
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={pristine || submitting}
          >
            Add
          </button>
          {` `}
        </div>
      </div>
    );
  }
}
const validate = values => {
  const errors = {};
  const required = ['client'];

  required.forEach(el => {
    if (!values[el]) {
      errors[el] = 'Required';
    }
  });

  return errors;
};

ClientForm = connect(state => ({
  enableReinitialize: true,
  validate: validate,
  initialValues: {
    isDefaul: false,
    isAnchorTenant: false
  }
}))(reduxForm({ form: 'LocationClientForm' })(ClientForm));
export default ClientForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/location/ClientForm.js